export default {
  add: {
    id: 'bo_seller_profile_page_tax_details_add',
    defaultMessage: 'Add',
  },
  addTaxDetails: {
    id: 'bo_seller_profile_page_tax_details_add_button',
    defaultMessage: 'Add tax information',
  },
  country: {
    id: 'bo_seller_profile_page_tax_details_country',
    defaultMessage: 'Country',
  },
  euEstablishmentLabel: {
    id: 'bo_seller_profile_page_tax_details_eu_establishment_label',
    defaultMessage: 'Do you have a permanent establishment in the EU?',
  },
  euEstablishmentRequired: {
    id: 'bo_seller_profile_page_tax_details_eu_establishment_required',
    defaultMessage: 'Establishment area is required.',
  },
  euLegalArealPickerLabel: {
    id: 'bo_seller_profile_page_tax_details_area_picker_eu',
    defaultMessage: 'European Union (EU)',
  },
  exemptedFromVat: {
    id: 'bo_seller_profile_page_tax_details_exempt_vat_label',
    defaultMessage:
      'I’m exempt from VAT because I own a small business with sales totaling less than the VAT threshold.',
  },
  fileInputLabel: {
    id: 'bo_seller_profile_page_tax_details_file_input_label',
    defaultMessage: 'Select file',
  },
  legalAreaFieldSetLabel: {
    id: 'bo_seller_profile_page_tax_details_area_fieldset_label',
    defaultMessage: 'Where is your business legally located?',
  },
  legalAreaRequired: {
    id: 'bo_seller_profile_page_tax_details_area_required',
    defaultMessage: 'Legal area is required',
  },
  expeditionCountryRequired: {
    id: 'bo_seller_profile_page_tax_details_expedition_country_required',
    defaultMessage: 'Shipping departure country is required',
  },
  loadingText: {
    id: 'bo_seller_profile_page_tax_details_loading_text',
    defaultMessage: 'Updating your tax details...',
  },
  marginSchemeInfoBlockContent: {
    id: 'bo_seller_profile_page_tax_details_info_block_content',
    defaultMessage:
      'A VAT margin scheme isn’t available for all secondhand goods. It’s your responsibility to determine if your items are eligible or not. To verify, reach out to your accountant or tax advisor. By submitting this information, you acknowledge that Back Market may charge you for any taxes, fees, penalties, or interest that Back Market may pay due to incorrect, incomplete, or obsolete information on your part.',
  },
  marginSchemeInfoBlockTitle: {
    id: 'bo_seller_profile_page_tax_details_info_block_title',
    defaultMessage:
      'By submitting this information, you’re confirming its accuracy.',
  },
  marginVatLabel: {
    id: 'bo_seller_profile_page_tax_details_margin_vat_label',
    defaultMessage:
      '100% of the items I plan to sell on Back Market are subject to a VAT margin scheme for secondhand goods.',
  },
  mixedVatLabel: {
    id: 'bo_seller_profile_page_tax_details_mixed_vat_label',
    defaultMessage:
      'I plan to sell some items that are subject to normal VAT and some items that are subject to a VAT margin scheme for secondhand goods.',
  },
  modalTitle: {
    id: 'bo_seller_profile_page_tax_details_modal_title',
    defaultMessage: 'Add your tax information',
  },
  no: {
    id: 'bo_seller_profile_page_tax_details_no',
    defaultMessage: 'No',
  },
  normalVatLabel: {
    id: 'bo_seller_profile_page_tax_details_normal_vat_label',
    defaultMessage:
      '100% of the items I plan to sell on Back Market are subject to normal VAT.',
  },
  notEuLegalArealPickerLabel: {
    id: 'bo_seller_profile_page_tax_details_area_picker_not_eu',
    defaultMessage: 'Non-EU country (including the UK)',
  },
  ossDocumentRequired: {
    id: 'bo_seller_profile_page_tax_details_oss_document_required',
    defaultMessage: 'OSS document is required.',
  },
  ossDocumentUploadHint: {
    id: 'bo_seller_profile_page_tax_details_oss_document_upload_hint',
    defaultMessage: 'Upload a copy of your OSS registration.',
  },
  ossRegistrationLabel: {
    id: 'bo_seller_profile_page_tax_details_oss_registration_label',
    defaultMessage: 'Are you registered with the One Stop Shop (OSS)?',
  },
  ossRegistrationRequired: {
    id: 'bo_seller_profile_page_tax_details_oss_registration_required',
    defaultMessage: 'OSS registration information is required.',
  },
  saveAsDraftTaxDetails: {
    id: 'bo_seller_profile_page_tax_details_save_details',
    defaultMessage: 'Save as draft',
  },
  taxIdHint: {
    id: 'bo_seller_profile_page_tax_details_tax_id_hint',
    defaultMessage: 'Tax number',
  },
  taxIdLabel: {
    id: 'bo_seller_profile_page_tax_details_tax_id_label',
    defaultMessage:
      'Enter your VAT, TIN/EIN, or tax ID number for your business’s country of residence.',
  },
  taxIdRequired: {
    id: 'bo_seller_profile_page_tax_details_tax_id_required',
    defaultMessage: 'Tax ID is required.',
  },
  vatByCountryLabel: {
    id: 'bo_seller_profile_page_tax_details_vat_by_country_label',
    defaultMessage:
      'Enter your VAT number for every country you plan to sell in.',
  },
  vatInformationsUpdateErrorMessage: {
    id: 'bo_seller_profile_page_tax_details_update_error_message',
    defaultMessage: 'Something went wrong while updating your tax details.',
  },
  vatInformationsUpdateErrorTitle: {
    id: 'bo_seller_profile_page_tax_details_update_error_title',
    defaultMessage: 'Oops!',
  },
  vatInformationsUpdateSuccessMessage: {
    id: 'bo_seller_profile_page_tax_details_update_success_message',
    defaultMessage: 'Your tax details have been updated.',
  },
  vatInformationsUpdateSuccessTitle: {
    id: 'bo_seller_profile_page_tax_details_update_success_title',
    defaultMessage: 'Perfect!',
  },
  vatMarginSchemeRequired: {
    id: 'bo_seller_profile_page_tax_details_vat_margin_scheme_required',
    defaultMessage: 'VAT margin scheme is required.',
  },
  vatNumber: {
    id: 'bo_seller_profile_page_tax_details_vat_number',
    defaultMessage: 'VAT Number',
  },
  vatNumberHint: {
    id: 'bo_seller_profile_page_tax_details_vat_number_hint',
    defaultMessage: 'Intra-community VAT number',
  },
  vatNumberLabel: {
    id: 'bo_seller_profile_page_tax_details_vat_number_label',
    defaultMessage:
      'Enter your intra-community VAT number for your business’s country of residence.',
  },
  vatNumberRequired: {
    id: 'bo_seller_profile_page_tax_details_vat_number_required',
    defaultMessage: 'Intra-community VAT number is required.',
  },
  vatNumberInvalidFormat: {
    id: 'bo_seller_profile_page_tax_details_vat_number_invalid_format',
    defaultMessage: 'Format error.',
  },
  vatNumbersByCountryRequired: {
    id: 'bo_seller_profile_page_tax_details_vat_numbers_by_country_required',
    defaultMessage: 'At least one VAT number is required.',
  },
  vatSchemeRadiosHint: {
    id: 'bo_seller_profile_page_tax_details_vat_scheme_radios_hint',
    defaultMessage:
      'Not sure? No worries. Save now and come back later to finish adding your VAT details.',
  },
  vatSchemeRadiosLabel: {
    id: 'bo_seller_profile_page_tax_details_vat_scheme_radios_label',
    defaultMessage: 'Which VAT scheme applies to the items you want to sell?',
  },
  yes: {
    id: 'bo_seller_profile_page_tax_details_yes',
    defaultMessage: 'Yes',
  },
  downloadButton: {
    id: 'bo_seller_profile_page_tax_details_buttons_download',
    defaultMessage: 'Download',
  },
  expeditionCountryLabel: {
    id: 'bo_seller_profile_page_tax_details_expedition_country',
    defaultMessage: 'Shipping from',
  },
  shippingFrom: {
    id: 'bo_seller_profile_page_tax_details_shipping_from',
    defaultMessage: 'Where do you ship your items from?',
  },
  vatInfoTooltip: {
    id: 'bo_seller_profile_page_tax_details_vat_info_tooltip',
    defaultMessage:
      'In order to ensure the validity of your VAT number, your VAT information will be periodically verified',
  },
}
